const PIXEL_ATTR = 'data-pixel-script';

let storedPixels = [];

const googleEventMap = {
    AddToCart: 'add_to_cart',
    InitiateCheckout: 'begin_checkout',
    AddPaymentInfo: 'add_payment_info',
    Lead: 'generate_lead',
    Purchase: 'purchase',
};

function fireMetaEvent(eventKey) {
    if (window.fbq) window.fbq('track', eventKey);
}

function fireGoogleEvent(eventKey) {
    if (window.gtag) window.gtag('event', googleEventMap[eventKey] || eventKey);
}

function fireTikTokEvent(eventKey) {
    if (window.ttq) window.ttq.track(eventKey);
}

const eventFirers = {
    meta: fireMetaEvent,
    google: fireGoogleEvent,
    tiktok: fireTikTokEvent,
};

function injectMetaPixel(pixelId) {
    const script = document.createElement('script');
    script.setAttribute(PIXEL_ATTR, `meta-${pixelId}`);
    script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${pixelId}');
        fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
}

function injectGooglePixel(pixelId) {
    const loader = document.createElement('script');
    loader.async = true;
    loader.src = `https://www.googletagmanager.com/gtag/js?id=${pixelId}`;
    loader.setAttribute(PIXEL_ATTR, `google-loader-${pixelId}`);
    document.head.appendChild(loader);

    const script = document.createElement('script');
    script.setAttribute(PIXEL_ATTR, `google-${pixelId}`);
    script.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${pixelId}');
    `;
    document.head.appendChild(script);
}

function injectTikTokPixel(pixelId) {
    const script = document.createElement('script');
    script.setAttribute(PIXEL_ATTR, `tiktok-${pixelId}`);
    script.textContent = "!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=[\"page\",\"track\",\"identify\",\"instances\",\"debug\",\"on\",\"off\",\"once\",\"ready\",\"alias\",\"group\",\"enableCookie\",\"disableCookie\",\"holdConsent\",\"revokeConsent\",\"grantConsent\"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r=\"https://analytics.tiktok.com/i18n/pixel/events.js\",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement(\"script\");n.type=\"text/javascript\",n.async=!0,n.src=r+\"?sdkid=\"+e+\"&lib=\"+t;e=document.getElementsByTagName(\"script\")[0];e.parentNode.insertBefore(n,e)};ttq.load('" + pixelId + "');ttq.page()}(window,document,'ttq');";
    document.head.appendChild(script);
}

const injectors = {
    meta: injectMetaPixel,
    google: injectGooglePixel,
    tiktok: injectTikTokPixel,
};

export function injectPixels(pixels) {
    if (!Array.isArray(pixels)) return;

    storedPixels = pixels;

    pixels.forEach(pixel => {
        if (!pixel.pixel_id) return;
        const inject = injectors[pixel.platform];
        if (inject) inject(pixel.pixel_id);
    });
}

export function trackEvent(eventKey) {
    storedPixels.forEach(pixel => {
        if (!pixel.tracking_events?.includes(eventKey)) return;

        const fire = eventFirers[pixel.platform];
        if (fire) fire(eventKey);
    });
}

export function cleanupPixels() {
    const scripts = document.querySelectorAll(`[${PIXEL_ATTR}]`);
    scripts.forEach(script => script.remove());
    storedPixels = [];
}
